import { Text } from 'react-aria-components';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Button, Menu, MenuItem, MenuTrigger, Popover } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { defaultSortOrdering, ensureSortParam } from './helpers';
import { useAiConfigFilters } from './hooks/useAiConfigFilters';

export function AiConfigOrdering() {
  const { view, updateOrdering } = useAiConfigFilters();

  const update = (sort: unknown) => {
    updateOrdering(ensureSortParam(sort));
  };

  return (
    <MenuTrigger>
      <Button variant="minimal">
        <Icon name="sort" size="small" /> {msg('aiConfigs.listOrdering.heading')}{' '}
        <Icon name="chevron-down" size="small" />
      </Button>
      <Popover placement="bottom">
        <Menu selectionMode="single" selectedKeys={new Set([view.sort ?? defaultSortOrdering])} onAction={update}>
          <MenuItem id="-creationDate">
            <Text slot="label">
              <Message id="aiConfigs.listOrdering.createdNewest" />
            </Text>
          </MenuItem>
          <MenuItem id="creationDate">
            <Text slot="label">
              <Message id="aiConfigs.listOrdering.createdOldest" />
            </Text>
          </MenuItem>
          <MenuItem id="name">
            <Text slot="label">
              <Message id="aiConfigs.listOrdering.nameAZ" />
            </Text>
          </MenuItem>
          <MenuItem id="-name">
            <Text slot="label">
              <Message id="aiConfigs.listOrdering.nameZA" />
            </Text>
          </MenuItem>
          <MenuItem id="-lastModified">
            <Text slot="label">
              <Message id="aiConfigs.listOrdering.lastModifiedNewest" />
            </Text>
          </MenuItem>
          <MenuItem id="lastModified">
            <Text slot="label">
              <Message id="aiConfigs.listOrdering.lastModifiedOldest" />
            </Text>
          </MenuItem>
        </Menu>
      </Popover>
    </MenuTrigger>
  );
}
